<template>
    <div class="questionPage">
        <homeHeader title="报名表列表">
            <el-button type="primary" @click="goCreateEnroll">创建报名表</el-button>
        </homeHeader>
        <div class="homeRightContent">
            <el-tabs class="questionTabs" v-model="searchForm.status" @tab-click="handleClick">
                <el-tab-pane label="全部" name="total"></el-tab-pane>
                <el-tab-pane label="已发布" name="1"></el-tab-pane>
                <el-tab-pane label="未发布" name="0"></el-tab-pane>
            </el-tabs>

            <el-form class="questionSearchForm" inline>
                <el-form-item>
                    <el-button icon="el-icon-delete" @click="onBatchDelete">删除</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button icon=" iconfont icon-qingkong" @click="clearDialogVisible = true">清空</el-button>
                </el-form-item>
                <el-form-item label="报名表名称">
                    <el-input v-model="searchForm.searchText" placeholder="请输入关键字"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSearch">搜索</el-button>
                </el-form-item>
            </el-form>
            <el-table width="100%" class="questionTable" :data="tableData" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label="报名表名称" prop="title"></el-table-column>
                <el-table-column label="宣传图" prop="bgPictureUrl">
                    <template slot-scope="scope">
                        <img :src="scope.row.bgPictureUrl" alt="" style="max-width: 134px; max-height: 75px;">
                    </template>
                </el-table-column>
                <el-table-column label="报名人数" prop="totalNum" min-width="80"></el-table-column>
                <el-table-column label="创建时间" prop="createDate" min-width="180"></el-table-column>
                <el-table-column label="状态" prop="status" min-width="80">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.status === 1 ? 'success' : 'warning'">{{ scope.row.status === 1 ? '已发布'
                            : '未发布' }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="200">
                    <template slot-scope="scope">
                        <div style="display: flex; align-items: center; gap: 16px;">
                            <el-link type="primary" :underline="false" @click="goEditEnroll(scope.row)">编辑</el-link>
                            <el-link type="primary" :underline="false" @click="deleteEnroll(scope.row)">删除</el-link>
                            <el-link v-if="scope.row.status === 1" type="primary"
                                :underline="false" @click="switchChange(scope.row)">取消发布</el-link>
                            <el-link v-else type="primary" :underline="false" @click="switchChange(scope.row)">发布</el-link>
                            <el-dropdown @command="(command) => handleCommand(command, scope.row)">
                                <span class="el-dropdown-link" style="cursor: pointer;">
                                    <i class="el-icon-more" style="color: #2c7dfa;"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="statistics">
                                        <div class="dropdown-item-content">
                                            <svg class="iconpark-icon">
                                                <use href="#tongjibaobiao"></use>
                                            </svg>统计
                                        </div>
                                    </el-dropdown-item>
                                    <el-dropdown-item command="copy">
                                        <div class="dropdown-item-content">
                                            <svg class="iconpark-icon">
                                                <use href="#fuzhi"></use>
                                            </svg>复制
                                        </div>
                                    </el-dropdown-item>
                                    <el-dropdown-item command="share">
                                        <div class="dropdown-item-content">
                                            <svg class="iconpark-icon">
                                                <use href="#fenxiang"></use>
                                            </svg>分享
                                        </div>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                layout="prev, pager, next"
                :current-page.sync="searchForm.pageNum"
                :page-size.sync="searchForm.pageSize"
                :total="total"
                @current-change="getQuestionList"
            >
            </el-pagination>


            <el-dialog :visible.sync="editDialogVisible" width="520px" class="editDialog" :show-close="false">
                <span>
                    <svg class="iconpark-icon">
                        <use href="#tixing"></use>
                    </svg>
                    <span class="text">编辑问卷可能导致已填结果出现偏差,请慎重选择,建议您复制问卷后进行编辑</span>
                </span>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" plain @click="copyEditHandle">复制后编辑</el-button>
                    <el-button type="primary" @click="editHandle">直接编辑</el-button>
                    <el-button @click="editDialogVisible = false">取消</el-button>
                </span>
            </el-dialog>
            <el-dialog :visible.sync="deleteDialogVisible" title="确认删除" width="420px" class="copyAndDelDialog">
                <span>确认删除已选择的报名表吗</span>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="deleteDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="deleteHandle">确 定</el-button>
                </span>
            </el-dialog>


            
            <el-dialog :visible.sync="shareDialogVisible" title="分享" class="shareDialog" width="600px">
                <span>
                    <el-row>
                        <el-col :span="16">
                            <p>社交网络分享</p>
                            <share :config="config" />
                            <p id="text">直接访问网址</p>
                            <div style="margin-top: 15px">
                                <el-input v-model="voteURL" style="position: relative; z-index: 999"
                                    class="input-with-select" :readonly="true">
                                    <el-button slot="append" class="copyURL" @click="copyText">复制</el-button>
                                </el-input>
                            </div>
                        </el-col>
                        <el-col :span="8" class="qrcode">
                            <img style="width: 140px; height: 140px" :src="qrcodeUrl" alt="" />
                            <p>扫一扫</p>
                            <p>分享到微信</p>
                        </el-col>
                    </el-row>
                    <el-row class="sendEmail">
                        <p style="margin: 10px 0">发送给参与人员</p>
                        <p style="color: #2b313c; font-size: 16px; margin: 0px">已关联活动：{{ currentItem.activityTitle }}</p>
                    </el-row>
                </span>
            </el-dialog>
            <el-dialog :visible.sync="copyDialogVisible" title="确认复制" width="420px" class="copyAndDelDialog">
                <span>确认复制已选择的报名表吗</span>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="copyDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="copyHandle(), (copyDialogVisible = false)">确
                        定</el-button>
                </span>
            </el-dialog>
            <el-dialog :visible.sync="batchDeleteDialogVisible" title="确认删除" width="420px" class="copyAndDelDialog">
                <span>确认删除已选择的报名表吗</span>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="batchDeleteDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="batchDeleteHandle">确
                        定</el-button>
                </span>
            </el-dialog>
            <el-dialog :visible.sync="clearDialogVisible" title="确认清空" width="420px" class="copyAndDelDialog">
                <span>确认清空全部报名表吗</span>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="clearDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="clearHandle">确
                        定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import homeHeader from '@/components/homeHeader.vue';
import { survey, errors } from '@/services/indexnew';
import conf from '@/config';
import copyText from 'ourwill-feutil/broswer/copyText'
const statusTotal = 'total';
export default {
    components: {
        homeHeader,
    },
    data() {
        return {
            searchForm: {
                status: statusTotal,
                searchText: '',
                pageNum: 1,
                pageSize: 5,
            },
            tableData: [],
            editDialogVisible: false,
            deleteDialogVisible: false,
            shareDialogVisible: false,
            currentItem: {},

            voteURL: '',
			config: {
				url: '', // 网址，默认使用 window.location.href
				source: '', // 来源（QQ空间会用到）, 默认读取head标签：<meta name="site" content="http://overtrue" />
				title: '投票页面', // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
				description: '投票页面', // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
				image: '', // 图片, 默认取网页中第一个img标签
				sites: ['qzone', 'qq', 'wechat', 'weibo'], // 启用的站点
				disabled: [], // 禁用的站点
				wechatQrcodeTitle: '微信扫一扫：分享', // 微信二维码提示文字
				wechatQrcodeHelper: '<p>扫一扫</p><p>分享到微信</p>',
			},
            qrcode: '',
            copyDialogVisible: false,

            selection: [],
            total: 0,
            batchDeleteDialogVisible: false,
            clearDialogVisible: false,
        }
    },
    computed: {
        qrcodeUrl() {
			return `${conf.ssrUrl}/qrcode/png/${btoa(this.voteURL)}.png?s=200`;
		},
    },
    mounted() {
        this.getQuestionList();
    },
    methods: {
        onSearch() {
            this.searchForm.pageNum = 1
            this.getQuestionList()
        },
        goCreateEnroll() {
            this.$router.push({
                path: '/setQuestionnaire/noId/create/0',
            });
        },
        async getQuestionList() {
            try {
                const { status, searchText, pageNum, pageSize } = this.searchForm;
                const { ok, data } = await survey.getSurveyListV2({
                    status: status === statusTotal ? '' : status,
                    searchText,
                    pageNum,
                    pageSize,
                });
                if (ok) {
                    this.tableData = data.data.records || [];
                    this.total = data.data.total || 0;
                    this.selection = [];
                }
            } catch (error) {
                errors.handle(error);
            }
        },
        handleClick() {
            this.searchForm.pageNum = 1;
            this.getQuestionList();
        },
        goEditEnroll(row) {
            this.editDialogVisible = true;
            console.log(row);
            this.currentItem = row;
        },
        //编辑
        editHandle() {
            console.log(this.currentItem);
            this.editDialogVisible = false;
            this.$router.push({
                path: `/setQuestionnaire/${this.currentItem.id}/edit/0`,
            });
        },
        //复制后编辑
        copyEditHandle() {
            const id = this.currentItem.id;
            survey.copyQuestionnaireAndVote(id).then(({ ok, data }) => {
                if (ok) {
                    this.$router.push({
                        path: `/setQuestionnaire/${id}/edit/0`,
                    });
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        //删除
        deleteEnroll(row) {
            this.deleteDialogVisible = true;
            this.currentItem = row;
        },
        //删除
        deleteHandle() {
            const id = this.currentItem.id;
            const list = this.tableData;

            survey.deleteQuestionnaireAndVote(id).then(({ data, ok }) => {
                if (ok) {
                    this.$message.success(data.msg);
                    this.deleteDialogVisible = false;
                    if (list.length - 1 == 0) {
                        this.searchForm.pageNum -= 1
                    }
                    this.getQuestionList();
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        //更改发布
        switchChange(row) {
            const { id, status } = row;
            survey.setQuestionnaireAndVoteStatus(id).then(({ ok, data }) => {
                if (ok) {
                    if (data.flag && data.flag == 50002) {
                        this.$message.error(data.msg);
                        return;
                    }
                    if (!status) {
                        this.$message.success('发布成功');
                        row.status = 1;
                    } else {
                        this.$message.success('取消发布成功');
                        row.status = 0;
                    }

                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        handleCommand(command, row) {
            this.currentItem = row;
            if (command === 'statistics') {
                this.dataCount();
            } else if (command === 'copy') {
                this.copyDialogVisible = true;
            } else if (command === 'share') {
                this.shareHandle();
            }
        },
        dataCount() {
            const { id, title, totalNum, oldMark } = this.currentItem;
			this.$router.push({
				name: 'questionnaireDataStatistics',
				params: { id: id, title: title, total: totalNum },
				query: { oldMark: oldMark ? 1 : 0 },
			});
		},
        //分享
		shareHandle() {
            this.voteURL = `${conf.surveyHost}/questionnaire/#/questionnaireVote/${this.currentItem.id}/write`
            const activityId = this.currentItem.activityId;
			if (activityId) {
				survey.getSendNum(activityId).then(({ ok, data }) => {
					if (ok) {
						this.sendNum = data.data;
					}
				});
			} else {
				this.sendNum = 0;
			}
			this.shareDialogVisible = true;

			if (!this.cl) {
				const self = this;
				setTimeout(() => {
					const cl = new clipboard(this.$el.querySelector('.copyURL'));
					cl.on('success', function (e) {
						self.$message.success('复制成功');
					});
					cl.on('error', function (e) {});
					this.cl = cl;
				}, 10);
			}
		},
        copyText() {
            copyText(this.voteURL);
        },
        //复制
		copyHandle() {
			const id = this.currentItem.id;
			survey.copyQuestionnaireAndVote(id).then(({ ok, data }) => {
				if (ok) {
					this.$message.success(data.msg);
					this.getQuestionList();
				} else {
					this.$message.error(data.msg);
				}
			});
		},
        //选择删除
        handleSelectionChange(val) {
            this.selection = val;
            console.log(val);
        },
        onBatchDelete() {
            if (this.selection.length == 0) {
                this.$message.error('请选择要删除的报名表');
                return;
            }
            this.batchDeleteDialogVisible = true;
        },
        //批量删除
        batchDeleteHandle() {
            const ids = this.selection.map(item => item.id);
            survey.batchDelete(ids).then(({ ok, data }) => {
            if (ok) {
                    this.$message.success(data.msg);
                    this.batchDeleteDialogVisible = false;
                    if (this.selection.length == this.tableData.length) {
                        this.searchForm.pageNum -= 1
                    }
                    this.getQuestionList();
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        clearHandle() {
            const { status } = this.searchForm;
            survey.delAll({ status: status === statusTotal ? '' : status }).then(({ ok, data }) => {
                if (ok) {
                    this.$message.success(data.msg);
                    this.getQuestionList();
                    this.clearDialogVisible = false;
                } else {
                    this.$message.error(data.msg);
                }
            });
        }
    },
}
</script>

<style lang="less">
.questionPage {
    overflow-x: hidden;
    .questionTabs {
        .el-tabs__content {
            display: none;
        }
    }

    .questionSearchForm {
        .el-button {
            i {
                font-size: 14px;

                +span {
                    margin-left: 8px;
                }
            }
        }
    }

    .questionTable {
        thead th {
            background-color: #f5f6fa;
        }
    }

    .editDialog {
        .el-dialog {
            padding: 0 123px;
            text-align: center;

            .el-dialog__header {
                padding: 0;
            }

            .el-dialog__body {
                padding: 40px 0 12px;

                .iconpark-icon {
                    height: 45px;
                    width: 45px;
                    margin-bottom: 22px;
                }

                .text {
                    display: block;
                    color: rgba(29, 33, 41, 1);
                    font-size: 12px;
                    line-height: 20px;
                    padding: 0 10px;
                }
            }

            .el-dialog__footer {
                padding: 12px 0 34px;

                span {
                    display: flex;
                    justify-content: space-between;
                    width: 100%;

                    .el-button {
                        font-size: 14px;
                        height: 32px;
                        position: relative;
                        padding: 5px 16px;
                    }

                    .el-button--primary {
                        background: rgba(52, 145, 250, 1);
                        border: none;
                        color: rgba(255, 255, 255, 1);
                    }

                    .el-button--primary.is-plain {
                        background: rgba(242, 243, 245, 1);
                        border: none;
                        color: rgba(52, 145, 250, 1);
                    }

                    .el-button--default {
                        border: 1px solid rgba(134, 144, 156, 1);
                        color: rgba(78, 89, 105, 1);
                    }
                }
            }
        }
    }

    .copyAndDelDialog {
        .el-dialog {
            height: 188px;

            .el-dialog__header {
                font-size: 16px;
                color: #333333;
            }

            .el-dialog__body {
                padding-left: 58px;
                font-size: 14px;
                color: #333333;
            }

            .el-dialog__footer {
                padding: 0 20px 0 0;
            }
        }
    }
    .shareDialog {
		.el-dialog__header {
			padding-bottom: 20px;
			border-bottom: 1px solid #d8dbe0;
		}
		.el-input {
			.el-input-group__append {
				background-color: #2c7dfa;
				color: #fff;
			}
		}
		.sendEmail {
			height: 210px;
			border-top: 1px solid #d8dbe0;
			.sendBtn {
				text-align: center;
				margin-top: 50px;
				margin-bottom: 5px;
				position: absolute;
				left: 50%;
				transform: translate(-50%);
				bottom: 0;
				.el-button {
					width: 120px;
					height: 42px;
					background: #2c7dfa;
					&.noSend {
						background: #409eff;
					}
				}
				.icon4 {
					width: 16px;
					height: 16px;
					color: #fff;
				}
				.icon5 {
					/*-webkit-transform: rotate(360deg);
                transform: rotate(360deg);
                -webkit-transition: -webkit-transform 1s linear;
                transition: transform 1s linear;*/
					-webkit-animation: spin 1s linear 1s 5 alternate;
					animation: spin 1s linear infinite;
				}
			}
		}
		.el-col-8 {
			text-align: center;
			box-sizing: border-box;
			padding-top: 10px;
			padding-bottom: 0;
			#qrcode {
				width: 120px;
				position: relative;
				left: 20px;
				margin-bottom: 10px;
			}
			p {
				margin: 0;
			}
		}
		.el-dialog__body {
			padding-bottom: 0px;
			.qrcode {
				padding: 0;
			}
		}
		.el-dialog__footer {
			height: 0;
			padding: 0;
		}
	}

    .el-pagination {
        .el-pager li.active + li {
            border-left: 1px solid #d9d9d9;
            &:hover {
                border: 1px solid #1890ff;
            }
        }
    }
}

.dropdown-item-content {
    display: flex;
    align-items: center;
    font-size: 14px;

    svg {
        margin-right: 8px;
    }

    &:hover {
        color: #2c7dfa;

        svg {
            fill: rgba(52, 145, 250, 1);
        }
    }
}
</style>